import { useMutation, useQuery } from '@apollo/client/react';
import { Box } from '@chakra-ui/react';
import useDebouncedValue from '@restart/hooks/useDebouncedValue';
import { REQUEST_BUILDER_GROUP_REQUEST_FRAGMENT } from '@src/components/sco/Requests/RequestBuilder';
import { RequestProfile, RequestProfileProps } from '@src/components/sco/Requests/RequestProfile/index';
import { GroupRequest } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React, { useEffect, useRef } from 'react';
export type RequestProfilePreviewProps = {
  regenerateOnChange?: () => any;
} & RequestProfileProps;
export const RequestProfilePreview: React.FC<RequestProfilePreviewProps> = props => {
  const query = useQuery(gql`
    query($groupRequestId: String) {
      groupRequest(groupRequestId: $groupRequestId) {
        id
        ${REQUEST_BUILDER_GROUP_REQUEST_FRAGMENT}
      }
    }
  `, {
    variables: {
      groupRequestId: props.groupRequestId
    }
  });
  const [regenerateGroupRequest, regenerateGroupRequestMutation] = useMutation(gql`
    mutation ($input: UpsertGroupRequestInput!) {
      upsertGroupRequest(input: $input) {
        groupRequest {
          id
          bodyAsMarkdown
          generatedBodyAsMarkdown
          displayTitle
          title
        }
      }
    }
  `);
  const groupRequest: GroupRequest = query.data?.groupRequest;
  const checksumValue = getChecksumValue(groupRequest);
  const debouncedChecksumValue = useDebouncedValue(checksumValue, 500);
  console.log({
    debouncedChecksumValue
  });
  const hasLoaded = useRef(false);
  useEffect(() => {
    if (!groupRequest) {
      return;
    }
    if (!hasLoaded.current) {
      hasLoaded.current = true;
      return;
    }
    if (props.regenerateOnChange) {
      props.regenerateOnChange();
    }
  }, [debouncedChecksumValue]);
  return <Box opacity={regenerateGroupRequestMutation.loading ? '0.5' : 1} width={'full'}>
      <RequestProfile groupRequestId={props.groupRequestId} isPreview={true} {...props} />
    </Box>;
};
const getChecksumValue = (groupRequest: GroupRequest) => {
  return [groupRequest?.requestingCompany?.name, groupRequest?.requestingCompany?.elevatorPitch, groupRequest?.requestingCompany?.industryKeys, groupRequest?.requestingCompany?.stageKey, groupRequest?.groupRequestTypeKey, groupRequest?.valueToRequester, groupRequest?.valueToResponder, groupRequest?.needExplanation, groupRequest?.compensationTypeKeys, groupRequest?.requestingCompany?.name, groupRequest?.requestingCompany?.elevatorPitch, groupRequest?.requestingCompany?.url, groupRequest?.location, groupRequest?.userSearch?.userRoleKeys, groupRequest?.userSearch?.requiredSkills, groupRequest?.userSearch?.relevantSkills, groupRequest?.investorSearch?.fundingGoalInDollars, groupRequest?.investorSearch?.fundingGoalStageKey, groupRequest?.bodyPromptAdditionalItems, groupRequest?.bodyPromptToneKeys, groupRequest?.investorSearch?.problemStatement, groupRequest?.investorSearch?.solutionStatement, groupRequest?.investorSearch?.marketSizeStatement, groupRequest?.investorSearch?.tractionStatement, groupRequest?.investorSearch?.financialsStatement, groupRequest?.investorSearch?.teamStatement, groupRequest?.investorSearch?.fundingGoalInDollars, groupRequest?.investorSearch?.fundingGoalStageKey, groupRequest?.investorSearch?.fundingGoalStructureKeys?.join(', ')].filter(Boolean).join('; ');
};